import api from '../../api';
// 获取视频列表
export function getBidsList(params) {
  return api.post('/bids/getBidsList.go', params, false, false).then(res => res);
}
// 添加公告
export function addBids(params) {
  return api.post('/bids/addBids.go', params, false, false).then(res => res);
}
// 添加公告
export function getBids(params) {
  return api.post('/bids/getBids.go', params, false, false).then(res => res);
}
// 添加公告
export function upBids(params) {
  return api.post('/bids/upBids.go', params, false, false).then(res => res);
}
// 删除公告
export function delBids(params) {
  return api.post('/bids/delBids.go', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/tendering.js